import { render, staticRenderFns } from "./elective_subject.vue?vue&type=template&id=2b4f4559&"
import script from "./elective_subject.vue?vue&type=script&lang=js&"
export * from "./elective_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports